module.exports = __webpack_public_path__ + "static/media/7405.f2af0e29.jpg";